import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormPentagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFormPentagon"><Path d="M22.2109 8.68262L18.3105 20.6855H5.68945L1.78906 8.68262L12 1.26367L22.2109 8.68262Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormPentagon;
